module.exports = ["Upala","FakeDai","BasicPoolFactory","ProtoGroup","ProtoGroup","ProtoGroup","BladerunnerDAO","UBIExampleDApp"]